// Copyright (c) 2016 Deere & Company

import {buildDealerString} from './build-dealer-string';
import {getStore} from '../../store-factory';

export const buildDealer = (dealer, displayFormatKey) => {

    if (dealer.account === '') {

        return '---';

    }

    const dealerFormat = displayFormatKey ?
        displayFormatKey :
        getStore().getState().user.details.settings.dealer.displayFormat.key;

    return buildDealerString(dealerFormat, dealer);

};



// WEBPACK FOOTER //
// ./src/shared/services/build-dealer.js